// The SPA is ONE build (frontend/dist), deployed once, bound to two custom domains:
// www.scribe11.com (marketing — the public site) and app.scribe11.com (the authenticated
// dashboard). Vue Router's own route matching is domain-agnostic — nothing stops it from
// rendering LandingView at app.scribe11.com/ or SystemsDevicesView at www.scribe11.com/app/
// systems unless something explicitly stops it. router/index.js's global guard is that
// something; this module is where both real absolute origins are defined, baked in at
// build time via Vite env vars (VITE_APP_ORIGIN / VITE_MARKETING_ORIGIN — see render.yaml).
//
// Falling back to window.location.origin when those env vars are unset means local dev,
// e2e runs, and any preview build collapse APP_ORIGIN === MARKETING_ORIGIN automatically —
// the guard below then always takes its no-op branch, so there is no split to reason about
// outside the real production build. Never hardcode a fallback absolute URL here; a wrong
// one would silently break every environment that doesn't set these two env vars.
function resolveOrigin(envValue) {
  const fallback = typeof window !== 'undefined' ? window.location.origin : ''
  return (envValue || fallback).replace(/\/$/, '')
}

export const APP_ORIGIN = resolveOrigin(import.meta.env.VITE_APP_ORIGIN)
export const MARKETING_ORIGIN = resolveOrigin(import.meta.env.VITE_MARKETING_ORIGIN)

// True only when the two origins are genuinely different AND the browser is currently on
// the app one — i.e. only in a real split-domain deployment, never in local dev.
export function isOnAppHost() {
  return typeof window !== 'undefined' &&
    APP_ORIGIN !== MARKETING_ORIGIN &&
    window.location.origin === APP_ORIGIN
}

export function isOnMarketingHost() {
  return typeof window !== 'undefined' &&
    APP_ORIGIN !== MARKETING_ORIGIN &&
    window.location.origin === MARKETING_ORIGIN
}
